module.exports = __webpack_public_path__ + "static/media/eventually.db96a895.ogg";